import { useState, useEffect } from "react";
import { useFilters } from "../Filters.hook";
import { showSeason, showDateRange } from "../../../Utils/Functions";

export const useTemporalFilter = () => {
	const { filters } = useFilters();
	const [showSeasonInput, setShowSeasonInput] = useState(filters.season ? true : false);

	return {
		filters,
		showSeasonInput: showSeasonInput,
		setShowSeasonInput: setShowSeasonInput
	};
};
